module.exports = __webpack_public_path__ + "static/media/barrel.d173b26e.svg";